import { makeStyles } from 'tss-react/mui';

export const useCombinationPackChipStyles = makeStyles()((theme) => ({
  chip: {
    minWidth: 60,
    maxWidth: 96,
    paddingInline: theme.spacing(0.5),
    borderRadius: theme.shape.borderRadiusMd,
    backgroundColor: theme.palette.accent.main,
    color: theme.palette.accent.contrastText,
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightRegular,
    '&&:hover': {
      color: theme.palette.accent.contrastText,
      backgroundColor: theme.palette.accent.dark,
    },
    '&&:active': {
      color: theme.palette.accent.contrastText,
      backgroundColor: theme.palette.accent.dark,
    },
  },
  label: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
}));
